import {
  BlocklistEntry,
  BlocklistSummary,
  type BlocklistAddRequest,
  type BlocklistPolicyInput,
  type BlocklistStatus,
} from '@bartizo/shared';
import { apiPageRequest, apiRequest, type Page } from './client.js';

/**
 * The fleet blocklist (knowledge doc section 12, "Fleet blocklist"; P11.6): what
 * every server keeps out, why, and until when.
 */

export interface BlocklistFilters {
  status?: BlocklistStatus | undefined;
  q?: string | undefined;
  cursor?: string | undefined;
}

export const listBlocklist = (filters: BlocklistFilters): Promise<Page<BlocklistEntry>> => {
  const params = new URLSearchParams();
  if (filters.status !== undefined) params.set('status', filters.status);
  if (filters.q !== undefined && filters.q !== '') params.set('q', filters.q);
  if (filters.cursor !== undefined) params.set('cursor', filters.cursor);
  const query = params.toString();
  return apiPageRequest(`/blocklist${query === '' ? '' : `?${query}`}`, { schema: BlocklistEntry });
};

export const getBlocklistSummary = (): Promise<BlocklistSummary> =>
  apiRequest('/blocklist/summary', { schema: BlocklistSummary });

export const addToBlocklist = (body: BlocklistAddRequest): Promise<BlocklistEntry> =>
  apiRequest('/blocklist', { method: 'POST', body, schema: BlocklistEntry });

export const removeFromBlocklist = (ip: string, reason: string): Promise<BlocklistEntry> =>
  apiRequest('/blocklist/remove', { method: 'POST', body: { ip, reason }, schema: BlocklistEntry });

export const putBlocklistPolicy = (policy: BlocklistPolicyInput): Promise<BlocklistSummary> =>
  apiRequest('/blocklist/policy', { method: 'PUT', body: policy, schema: BlocklistSummary });
